"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationFacade = void 0;
const tslib_1 = require("tslib");
const deepmerge_1 = tslib_1.__importDefault(require("deepmerge"));
const axios_1 = require("@goparrot/axios");
const common_1 = require("@goparrot/common");
const generated_dto_1 = require("../generated-dto");
const dto_1 = require("../dto");
class LocationFacade extends axios_1.AbstractFacade {
    constructor(config = {}, interceptors) {
        super(deepmerge_1.default.all([
            {
                axiosConfig: {
                    baseURL: process.env.GOPARROT_PLATFORM_SERVICE_MENU_ORCHESTRATOR,
                },
            },
            config,
        ]), interceptors);
    }
    async list(merchantId) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadLocationDto, (await this.client.get(`api/v1/merchants/${encodeURIComponent(merchantId)}/locations`)).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
    async listGrouped(merchantId) {
        return (0, common_1.plainToInstanceWithLVS)(dto_1.GroupedLocationsDto, (await this.client.get(`api/v1/merchants/${encodeURIComponent(merchantId)}/locations/grouped`)).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
    async getCentralLocation(merchantId) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadLocationDto, (await this.client.get(`api/v1/merchants/${encodeURIComponent(merchantId)}/locations/central`)).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
    async get(merchantId, locationId) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadLocationDto, (await this.client.get(`api/v1/merchants/${encodeURIComponent(merchantId)}/locations/${encodeURIComponent(locationId)}`)).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
    async create(merchantId, data) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadLocationDto, (await this.client.post(`api/v1/merchants/${encodeURIComponent(merchantId)}/locations`, data)).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
    async createMany(merchantId, data, syncGridLayout = false) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadLocationDto, (await this.client.post(`api/v1/batch/merchants/${encodeURIComponent(merchantId)}/locations`, { data, syncGridLayout })).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
    async patch(merchantId, locationId, data) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadLocationDto, (await this.client.patch(`api/v1/merchants/${encodeURIComponent(merchantId)}/locations/${encodeURIComponent(locationId)}`, data))
            .data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
    async batchPatch(merchantId, data) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadLocationDto, (await this.client.patch(`api/v1/batch/merchants/${encodeURIComponent(merchantId)}/locations`, data)).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
    async update(merchantId, locationId, data) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadLocationDto, (await this.client.put(`api/v1/merchants/${encodeURIComponent(merchantId)}/locations/${encodeURIComponent(locationId)}`, data))
            .data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
    async delete(merchantId, locationId) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadLocationDto, (await this.client.delete(`api/v1/merchants/${encodeURIComponent(merchantId)}/locations/${encodeURIComponent(locationId)}`)).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
    async deleteByMerchant(merchantId) {
        return (await this.client.delete(`api/v1/batch/merchants/${encodeURIComponent(merchantId)}/locations`)).data;
    }
    async updateCatalogByItemSets(merchantId, data) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadLocationDto, (await this.client.patch(`api/v1/batch/merchants/${encodeURIComponent(merchantId)}/locations/item-sets`, data)).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
    async linkToLocation(merchantId, data) {
        return (0, common_1.plainToInstanceWithLVS)(generated_dto_1.ReadLocationDto, (await this.client.patch(`api/v1/merchants/${encodeURIComponent(merchantId)}/locations/central/link-to-location`, data)).data, {
            groups: [common_1.DefaultExposeGroupEnum.READ],
        });
    }
}
exports.LocationFacade = LocationFacade;
//# sourceMappingURL=LocationFacade.js.map